import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'groupBy',
    standalone: false
})
export class GroupByPipe implements PipeTransform {
    returnArray = []
    transform(collection: Array<any>, property: string): Array<any> {
        // prevents the application from breaking if the array of objects doesn't exist yet
        if(!collection) {
            return null;
        }

        const groupedCollection = collection.reduce((previous, current)=> {
            if(!previous[current[property]]) {
                previous[current[property]] = [current];
            } else {
                previous[current[property]].push(current);
            }

            return previous;
        }, {});

        // this will return an array of objects, each object containing a group of objects
        this.returnArray = Object.keys(groupedCollection).map(key => ({ key, value: groupedCollection[key] }));
        // console.log(this.returnArray); Use this for testing object transformation - Patrick M
        return this.returnArray; 
    }
}